import type { BaseCabItemOption } from '@/api';

export const getCabAttributes = (cabOption: BaseCabItemOption) => {
	const { displayPrice, strikePrice = displayPrice } = cabOption.pricing;
	return {
		'Cab Type': cabOption.vehicleType,
		'Fuel Type': cabOption.fuelType,
		Fare: strikePrice,
	};
};
